import React, { useState } from 'react';
import moment from 'moment';
import { useLocation } from "react-router-dom";
import {
     UK_POSTCOSR_REGEX,
     MPAN_CORE_REGEX,
     MPAN_FULL_REGEX,
     FUEL_TYPE_ELECTRICITY, 
     ELECTRICITY_QUERY, 
     GAS_QUERY,
     MSN_REGEX,
     MPRN_REGEX,
     POSTCODE,
     METER_POINT_ADMINISTRATION_NUMBER,
     METER_POINT_REFERENCE_NUMBER,
     METER_SERIAL_NUMBER, 
    } from "../../config/AppConfigurator";
import { QueryDetails } from '../../components/QueryDetails/QueryDetails';
import { Postcode } from '../../components/Postcode/Postcode';
import { MeterPointAdministrationNumber } from '../../components/MeterPointAdministrationNumber/MeterPointAdministrationNumber';
import { MeterSerialNumber } from '../../components/MeterSerialNumber/MeterSerialNumber';
import { MeterPointReferenceNumber } from '../../components/MeterPointReferenceNumber/MeterPointReferenceNumber';
import { Title } from '../../components/Title/Title';
import { createAddressString } from '../../utils/utils';

/* SERVICES */
import { getToken } from '../../services/getToken';
import { getAddressList } from '../../services/getAddressList';
import { getAddessDetails } from '../../services/getAddessDetails';

/* IMPORT STYLES FOR METER DATA ENQUIRY METHOD SELECTION CONTAINER */ 
import './MeterDataEnquiryPanel.scss';

export const MeterDataEnquiryPanel = () => {
    const location = useLocation();   
    const [postcode, setPostcode] = useState('');
    const [mpan, setMpan] = useState('');
    const [msn, setMsn] = useState('');
    const [mprn, setMprn] = useState('');
    const [fetchingAddresses, setFetchingAddresses] = useState(false);
    const [addressBtnSpinner, setAddressBtnSpinner] = useState(false);
    const [queryBtnSpinner, setQueryBtnSpinner] = useState(false);
    const [addressesList, setAddressesList] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState('');
    const [selectedAddressDetails, setSelectedAddressDetails] = useState({});
    const [queryDetails, setQueryDetails] = useState([]);
    const [showSubmit, setShowSubmit] = useState(true);

    /* Accessing and setting the session storage values */ 
    const accessToken = JSON.parse(sessionStorage.getItem('accessToken'));
    const userAuthorization = JSON.parse(sessionStorage.getItem('userAuthorization'));
    const tokenFetchTime = moment(JSON.parse(sessionStorage.getItem('tokenCallingTime')));

    const fetchAddressList = ()=> {
        const currentTime = moment(moment().format());

        if(selectedAddress.length > 0 ){
            setSelectedAddress('');
        }
        
        setAddressBtnSpinner(true);

        if(currentTime.diff(tokenFetchTime, "minutes") <= 55) {
            getAddressList(location.state.fuelType, postcode, accessToken, userAuthorization).then((data) => {
                setAddressesList(data);
                setFetchingAddresses(true);
                setAddressBtnSpinner(false);
                setShowSubmit(false);
            }).catch((e)=>{
                setShowSubmit(true);
                return [];
            });
        } else {
            getToken().then((data)=>{
                sessionStorage.setItem('accessToken', JSON.stringify(data.access_token));
                sessionStorage.setItem('tokenCallingTime', JSON.stringify(moment().format()));
            })

            getAddressList(location.state.fuelType, postcode, accessToken, userAuthorization).then((data) => {
                setAddressesList(data);
                setFetchingAddresses(true);
                setAddressBtnSpinner(false);
                setShowSubmit(false);
            }).catch((e)=>{
                setShowSubmit(true);
                return [];
            });
        }
    }

    const getSelectedAddress = (pickedAddress)=>{
        setSelectedAddressDetails(pickedAddress);
        setSelectedAddress(pickedAddress.text);
    }

    const resetSelectedAddress = ()=> {
        setSelectedAddress('');
    }

    const getMeterDataEnquiryDetails = ()=> {
        const currentTime = moment(moment().format());
        
        const adressDetailsReqDetails = {
            postcode: selectedAddressDetails.postcode || "",
            mpan: mpan || "",
            mprn: mprn || "",
            electricMeterSerialNumber: msn ||"",
            mpancore: "",
            xoserveAddressCode: "",
            mpancores: selectedAddressDetails.mpancore || [],
            xoserveAddressCodes: selectedAddressDetails.xoserveAddressCode || []
          }

        setQueryBtnSpinner(true);

        if(currentTime.diff(tokenFetchTime, "minutes") <= 55) {
            getAddessDetails(
                adressDetailsReqDetails.postcode, 
                adressDetailsReqDetails.mpan, 
                adressDetailsReqDetails.mprn, 
                adressDetailsReqDetails.electricMeterSerialNumber, 
                adressDetailsReqDetails.mpancore, 
                adressDetailsReqDetails.xoserveAddressCode, 
                adressDetailsReqDetails.mpancores, 
                adressDetailsReqDetails.xoserveAddressCodes, 
                accessToken, userAuthorization).then((data)=>{
                    setQueryBtnSpinner(false);
                    setQueryDetails(data);
                })
        } else {
            getToken().then((data)=>{
                sessionStorage.setItem('accessToken', JSON.stringify(data.access_token));
                sessionStorage.setItem('tokenCallingTime', JSON.stringify(moment().format()));
            })

            getAddessDetails(
                adressDetailsReqDetails.postcode, 
                adressDetailsReqDetails.mpan, 
                adressDetailsReqDetails.mprn, 
                adressDetailsReqDetails.electricMeterSerialNumber, 
                adressDetailsReqDetails.mpancore, 
                adressDetailsReqDetails.xoserveAddressCode, 
                adressDetailsReqDetails.mpancores, 
                adressDetailsReqDetails.xoserveAddressCodes, 
                accessToken, userAuthorization).then((data)=>{
                    setQueryBtnSpinner(false);
                    setQueryDetails(data);
                })
        }
    }

    const getPostalcode = (e)=> {
        var postcode = e.target.value;
        setShowSubmit(true);
        setPostcode(postcode.replace(/\s/g, ""));
    }

    const getMPAN = (e)=> {
        setMpan(e.target.value);
    }

    const getMSN = (e)=> {
        setMsn(e.target.value);
    }

    const getMPRN = (e)=> {
        setMprn(e.target.value);
    }

    return (
        <>
            <div className='meter-data-enquiry-panel-head'>
                { location && location.state && location.state.fuelType === FUEL_TYPE_ELECTRICITY ? 
                    <Title title={ ELECTRICITY_QUERY } />
                    : 
                    <Title title={ GAS_QUERY } />
                }
            </div>
            <div className="row gy-3 meter-data-enquiry-panel-top">
                { location && location.state && location.state.methodType === POSTCODE &&
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <Postcode 
                            regex={ UK_POSTCOSR_REGEX }
                            addressesList={ addressesList } 
                            fetchingAddresses={ fetchingAddresses } 
                            postcode={ postcode } 
                            addressBtnSpinner={ addressBtnSpinner }
                            selectedAddress={ selectedAddress }
                            queryBtnSpinner={ queryBtnSpinner }
                            showSubmit={ showSubmit }
                            fetchAddressList={ fetchAddressList } 
                            getPostalcode={ getPostalcode }
                            resetSelectedAddress={ resetSelectedAddress }
                            getSelectedAddress={ getSelectedAddress } 
                            getMeterDataEnquiryDetails={ getMeterDataEnquiryDetails }
                         />
                    </div>
                }
                { location && location.state && location.state.methodType === METER_POINT_ADMINISTRATION_NUMBER &&
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <MeterPointAdministrationNumber 
                            regexMPANCore={ MPAN_CORE_REGEX }
                            regexMPANFull={ MPAN_FULL_REGEX }
                            addressBtnSpinner={ addressBtnSpinner }
                            queryBtnSpinner={ queryBtnSpinner }
                            mpan={ mpan }
                            queryDetails={ queryDetails } 
                            getMPAN={ getMPAN }
                            getMeterDataEnquiryDetails={ getMeterDataEnquiryDetails }
                            address={createAddressString(
                                queryDetails && queryDetails[0] && queryDetails[0].addressLine1,
                                queryDetails && queryDetails[0] && queryDetails[0].addressLine2,
                                queryDetails && queryDetails[0] && queryDetails[0].city,
                                queryDetails && queryDetails[0] && queryDetails[0].postcode
                            )}
                        />
                    </div>
                }
                { location && location.state && location.state.methodType === METER_SERIAL_NUMBER &&
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <MeterSerialNumber 
                            regexMSN={ MSN_REGEX }
                            addressBtnSpinner={ addressBtnSpinner }
                            queryBtnSpinner={ queryBtnSpinner }
                            msn={ msn }
                            queryDetails={ queryDetails } 
                            getMSN={ getMSN }
                            getMeterDataEnquiryDetails={ getMeterDataEnquiryDetails }
                            address={createAddressString(
                                queryDetails && queryDetails[0] && queryDetails[0].addressLine1,
                                queryDetails && queryDetails[0] && queryDetails[0].addressLine2,
                                queryDetails && queryDetails[0] && queryDetails[0].city,
                                queryDetails && queryDetails[0] && queryDetails[0].postcode
                            )}
                        />
                    </div>
                }
                { location && location.state && location.state.methodType === METER_POINT_REFERENCE_NUMBER &&
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <MeterPointReferenceNumber 
                            regexMPRN={ MPRN_REGEX }
                            addressBtnSpinner={ addressBtnSpinner }
                            queryBtnSpinner={ queryBtnSpinner }
                            mprn={ mprn }
                            queryDetails={ queryDetails } 
                            getMPRN={ getMPRN }
                            getMeterDataEnquiryDetails={ getMeterDataEnquiryDetails }
                            address={createAddressString(
                                queryDetails && queryDetails[0] && queryDetails[0].addressLine1,
                                queryDetails && queryDetails[0] && queryDetails[0].addressLine2,
                                queryDetails && queryDetails[0] && queryDetails[0].city,
                                queryDetails && queryDetails[0] && queryDetails[0].postcode
                            )}
                        />
                    </div>
                }
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <QueryDetails 
                        queryDetails={ queryDetails } 
                        queryType={ location && location.state && location.state.fuelType }
                    />
                </div>
            </div>
        </>
    );
};
